export class ChatMessages {
  readonly NameRequiredMesssage = 'Please enter a name.';
  readonly TopicRequiredMesssage = 'Please select a chat topic.';
  readonly EmailValidationMessage = 'Are you sure your email address is correct? The format does not' +
  ' appear to be valid (yourname@example.com) If you continue to receive this message,' +
  ' please leave the field blank.';
  readonly PhoneNumberValidation = 'When entering your phone number, please use ten digits without any ' +
  'spaces or characters. If you continue to receive this message, please leave this field blank.';
  readonly ChatErrorMessage = `Oops! Something went wrong on our end.<br /><br />
                              If the problem continues, please contact our customer service department at 800.727.6331.<br /><br />
                              Thank you!`;
  readonly ChatCloseConfirmationMessage = 'Are you sure you want to close this chat session?';
  readonly CallBackConfirmationMessage = `Your request for a phone call from one of our Customer Service representatives has been received.
                        <br /><br />If you require urgent assistance prior to receiving a call
                        , please contact us at 800.727.6331.<br /><br />Thank you!`;
  readonly UserChatMessageTemplate = `<div class='chatUserMessage'><<displayName>>
  [<<chatTime>>]<br/><span style=\'font-weight:bold\'><<message>></span></div>`;
  readonly RepChatMessageTemplate = `<div class='chatAgentMessage'><<displayName>>
  [<<chatTime>>]<br/><span style=\'font-weight:bold\'><<message>></span></div>`;
}
